const obsScoreConfig = window.obsScoreConfig;


export default obsScoreConfig;
